<div class="panneau-patient-adresse__container">
	<di-formulaire-patient
		[patient]="patient"
		[showIdentityInputs]="false"
		[showLocationInputs]="true"
		[isPanneau]="true"
		libelleButton="Enregistrer"
		[onSubmit]="updatePatient"
	></di-formulaire-patient>
</div>
